/**
 * A tiny, deterministic tilt per note (±0.35deg) — enough for the board to
 * read as loose paper rather than a rigid card grid, never enough to look
 * randomly rotated. Hashed from the note's own id so it never changes
 * between renders.
 */
function paperTiltForNote(id: string): number {
  let hash = 0
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) | 0
  }
  const normalized = (Math.abs(hash) % 100) / 100
  return (normalized - 0.5) * 0.7
}

export { paperTiltForNote }
